<dialog-draggable-header>Send Email Notification</dialog-draggable-header>

<div class="email-container">
  <div class="left-container">
    <p-tree [value]="folders" selectionMode="checkbox" [(selection)]="selection" [propagateSelectionUp]="false"
      [propagateSelectionDown]="false" (onNodeSelect)="onTreeSelectionChange($event)"
      (onNodeUnselect)="onTreeSelectionChange($event)">
    </p-tree>
  </div>
  <div class="right-container">
    <data-table #emailsTable [data]="emails" [columns]="columns" [filterColumnDisplay]="false" [lazy]="true"
      [totalRecords]="totalEmails" [multiselect]="true" [paging]="true" [pageSize]="pageOptions.size"
      (lazyLoad)="onLazyLoad($event)">
      <ng-container actionStart>
        Checking Fixture No: {{this.fixtureNo}}
        <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
        Part No Lh or Single: {{this.partNumber}}
      </ng-container>
      <ng-container actionEnd>
        <button mat-button (keydown.enter)="send()" (click)="send()"
          matTooltip="Click to send an e-mail to the selected contacts.">Send</button>
        <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
        <button mat-button (keydown.enter)="close()" (click)="close()">Close</button>
      </ng-container>
    </data-table>
  </div>
</div>